const facets = {
	init: () => {
		facets.events();
		facets.resize();
		$(window).on('resize', () => facets.resize());
	},

	resize: () => {
		if($(window).width() > 1024) {
			$('.facets').addClass('open');
			$('.facet-toggle').attr('aria-expanded', 'true');
		} else {
			$('.facets').removeClass('open');
			$('.facet-toggle').attr('aria-expanded', 'false');
		}
	},

	events: () => {
		// Toggle facets sidebar
		$(document).on('click', '.facet-toggle', function(e) {
			e.preventDefault();
			const $this = $(this);
			const $parent = $this.closest('.facets');
			if($parent.hasClass('open')) {
				$parent.removeClass('open');
				$this.attr('aria-expanded', 'false');
			} else {
				$parent.addClass('open');
				$this.attr('aria-expanded', 'true');
			}
		});

		// Toggle filter dropdowns
		$(document).on('click', '.filters .filter h3', function(e) {
			e.preventDefault();
			const $filter = $(this).closest('.filter');
			if($filter.hasClass('open')) {
				$filter.removeClass('open').find('.filter__values').slideUp(200);
				$filter.find('.filter__values').css('left', '0px');
			} else {
				$('.filters .filter').removeClass('open').find('.filter__values').slideUp(200).css('left', '-1px');
				$filter.addClass('open').find('.filter__values').slideDown(200);

				// reposition if overflowing viewport
				const $values = $filter.find('.filter__values');
				const leftPos = $values.offset().left;
				const valuesWidth = $values.outerWidth();
				const viewportWidth = $(window).width();

				if(leftPos + valuesWidth > viewportWidth) {
					const offset = viewportWidth - (leftPos + valuesWidth);
					$values.css('left', offset + 'px');
				} else {
					$values.css('left', '0px');
				}
			}
		});

		// Close filter dropdowns on outside click
		$(document).on('click', function(e) {
			if(!$(e.target).closest('.filters .filter').length) {
				$('.filters .filter').removeClass('open').find('.filter__values').slideUp(200);
			}
		});

		// Checkbox filters
		$(document).on('change', '.filter__values input[type="checkbox"]', function() {
			const $this = $(this);
			const filterName = $this.attr('name');
			const filterValue = $this.val();
			const isChecked = $this.is(':checked');

			if(isChecked) {
				facets.updateUrl(filterName, filterValue);
			} else {
				facets.updateUrl(filterName, null);
			}

			facets.fetchResults(window.location.href);
		});

		// Remove active filter chips
		$(document).on('click', '.active-facet', function(e) {
			e.preventDefault();
			const url = $(this).attr('href');
			window.history.pushState({}, '', url.toString());
			facets.fetchResults(window.location.href);
		});

		// ✅ Handle sort_by dropdown
		$(document).on('change', 'select[name="sort_by"]', function() {
			const url = new URL(window.location.href);
			url.searchParams.set('sort_by', $(this).val());
			window.history.pushState({}, '', url.toString());
			facets.fetchResults(url.toString());
		});
	},

	updateUrl: (param, value) => {
		const url = new URL(window.location.href);
		const searchParams = new URLSearchParams(url.search);

		if(value) {
			if(searchParams.has(param)) {
				const existingValues = searchParams.getAll(param);
				existingValues.push(value);
				searchParams.delete(param);
				existingValues.forEach(val => searchParams.append(param, val));
			} else {
				searchParams.append(param, value);
			}
		} else {
			searchParams.delete(param);
		}
		
		url.search = searchParams.toString();
		window.history.pushState({}, '', url.toString());
	},

	fetchResults: (url) => {
	$('.collection-product-grid-container').addClass('loading');

	return fetch(url)
		.then(response => response.text())
		.then(html => {
			const parser = new DOMParser();
			const doc = parser.parseFromString(html, 'text/html');

			const productGrid = doc.querySelector('#product-grid');
			if(productGrid) {
				document.querySelector('#product-grid').innerHTML = productGrid.innerHTML;
			}

			const facetsContainer = doc.querySelector('.facets');
			if(facetsContainer) {
				document.querySelector('.facets').innerHTML = facetsContainer.innerHTML;
			}

			const pagination = doc.querySelector('.pagination-wrapper');
			if(pagination) {
				document.querySelector('.pagination-wrapper').innerHTML = pagination.innerHTML;
			}

			$('.collection-product-grid-container').removeClass('loading');

			/** 🔥 Reinitialize Discount Badges **/
			if (typeof window.renderDiscountOverlays === "function") {
				// If your app provides a re-render method
				window.renderDiscountOverlays();
			} else {
				// Fallback: trigger mutation observer again or re-scan DOM
				document.querySelectorAll('.product-card').forEach(el => {
					el.removeAttribute('data-rendered-discount-ov');
					el.classList.remove('has-discount-overlay');
				});
				// Small delay to let the app re-attach itself
				setTimeout(() => {
					const evt = new Event("DOMContentLoaded", { bubbles: true });
					document.dispatchEvent(evt);
				}, 300);
			}
		})
		.catch(error => console.error('Error fetching results:', error));
}

};

jQuery(() => {
	if($('.facets').length) facets.init();
});
